var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.5 24.1 4.6 7.4c-.6-.2-1.2-.1-1.6.3-.4.3-.6.9-.4 1.5l4.3 16.3-4.3 16.3c-.1.5 0 1.1.5 1.5.3.2.6.4 1 .4.2 0 .4 0 .6-.1l42-16.7c.6-.2.9-.8.9-1.4s-.5-1.2-1.1-1.4M6.2 11.3 38.1 24l-28.6-.1zm3.3 15.6 28.7.1-32 12.8z"
  })));
};
export default SvgSend;